/**
 * Cliente HTTP de `/operaciones.html` — Fase 8b.
 *
 * Solo `GET /api/operations` (endpoint público, no requiere sesión).
 * El backend devuelve campañas + misiones ya agregadas con counts y
 * flags para minimizar round-trips.
 */

import type { OperationsResponse } from '@51esc/shared';

export type FetchOperationsResult =
  | { ok: true; data: OperationsResponse }
  | { ok: false; message: string };

export async function fetchOperations(): Promise<FetchOperationsResult> {
  let res: Response;
  try {
    res = await fetch('/api/operations', { credentials: 'include' });
  } catch (err) {
    console.error('[operaciones] fetch network err', err);
    return { ok: false, message: 'No se pudo contactar con el servidor.' };
  }
  if (!res.ok) {
    return {
      ok: false,
      message: `El servidor respondió con ${String(res.status)}.`,
    };
  }
  let body: unknown = null;
  try {
    body = await res.json();
  } catch {
    return { ok: false, message: 'Respuesta del servidor inválida.' };
  }
  if (
    typeof body !== 'object' ||
    body === null ||
    !Array.isArray((body as OperationsResponse).campaigns) ||
    !Array.isArray((body as OperationsResponse).missions)
  ) {
    return { ok: false, message: 'Respuesta del servidor inválida.' };
  }
  return { ok: true, data: body as OperationsResponse };
}
